/** Invoicing group (canonical `M8XIPbVz`) — Fees (Brief 04). A fee is a
 *  contracted line item on a job (the "order book"). Fees live entirely in this
 *  group, NOT in the Jobs /detail payload, so the Fees tab fetches + refreshes
 *  against GET /fees?job_id and never touches /detail. amount_invoiced /
 *  amount_paid / status are system-managed — never sent from the UI. */

import { api } from "./client";
import type {
  Fee,
  FeesListResponse,
  FeeCreateInput,
  FeeUpdateInput,
  FeeDeleteResponse,
} from "@/types";

/** GET /fees?job_id — a job's fees + financial summary. */
export function listFees(jobId: number): Promise<FeesListResponse> {
  return api.get<FeesListResponse>("inv", "fees", { query: { job_id: jobId } });
}

/** POST /fees/create — add a fee to the job (status starts "pending"). */
export function createFee(input: FeeCreateInput): Promise<Fee> {
  return api.post<Fee>("inv", "fees/create", { body: input });
}

/** PATCH /fees/{id} — edit description/amount/fee_type/notes. 400 if amount <
 *  amount_invoiced, or fee_type invalid. */
export function updateFee(id: number, patch: FeeUpdateInput): Promise<Fee> {
  return api.patch<Fee>("inv", `fees/${id}`, { body: patch });
}

/** DELETE /fees/{id} — delete an unbilled fee. 400 if it has invoice lines. */
export function deleteFee(id: number): Promise<FeeDeleteResponse> {
  return api.delete<FeeDeleteResponse>("inv", `fees/${id}`);
}
